// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__8Dj5p","progressBar":"styles_progressBar__iel1K"};